/**
 * Core-100 R4 W1 (CORE-M / CORE-D time boundary). Passport periods are DATE-ONLY facts ('2020-01-01'). `new Date('2020-01-01')`
 * parses that as UTC midnight, so in every timezone west of UTC it renders as the previous day — a programme that
 * started 1 Jan 2020 showed "2019", an employment that began 1 Mar showed "Feb". And `new Date().toISOString()` is the
 * UTC date, which after ~19:00 in the US is already tomorrow, so an education that ends today was called "ended".
 * Both are read here in the viewer's LOCAL calendar.
 */
import { format, parseISO } from 'date-fns';

/** A date-only (or timestamp) string as the local calendar day it names. */
export function parseDateOnly(value: string): Date {
  return parseISO(value.slice(0, 10));
}

/** Today's date in the viewer's local calendar, as 'yyyy-MM-dd'. */
export function localTodayIso(now: Date = new Date()): string {
  return format(now, 'yyyy-MM-dd');
}
